import { useContext } from 'react';

import { ContactStateContext } from '../contexts';

const useContactState = () => useContext(ContactStateContext);

export default useContactState;
